interface DepartmentHeaderProps {
  name: string;
  jurisdiction?: string;
  stateCode?: string;
}

export const DepartmentHeader = ({
  name,
  jurisdiction,
  stateCode,
}: DepartmentHeaderProps) => {
  const location = [jurisdiction, stateCode].filter(Boolean).join(', ');

  return (
    <div>
      <h1 className="text-lg font-semibold leading-tight text-gray-900">
        {name || 'Unnamed Department'}
      </h1>
      {location && <p className="mt-1 text-sm text-gray-600">{location}</p>}
    </div>
  );
};
